import { render, staticRenderFns } from "./folder-tags.vue?vue&type=template&id=b6a91db0&scoped=true&"
import script from "./folder-tags.vue?vue&type=script&lang=js&"
export * from "./folder-tags.vue?vue&type=script&lang=js&"
import style0 from "./folder-tags.vue?vue&type=style&index=0&id=b6a91db0&prod&scoped=true&lang=css&"
import style1 from "./folder-tags.vue?vue&type=style&index=1&id=b6a91db0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a91db0",
  null
  
)

export default component.exports